<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="deleting_post">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Deleting, please wait
        </div>
      </div>
    </div>
    <div class="box-content">
      <div class="flex-xs justify-end mb-3">
        <div class="flex-xs mb-1 mb-0-xs">
          <div class="pr-1-xs">
            <a class="btn-primary" href="/news/categories">
              Manage Categories
            </a>
          </div>
          <div class="pr-1-xs">
            <a class="btn-primary" href="/news/create">
              Add New
            </a>
          </div>
          <div class="form-group mb-0 pr-1-xs" style="width: 200px;">
            <div class="multi-select-input">
              <div class="multi-select-input-placeholder" @click="category_dropdown_open = !category_dropdown_open">
                <template v-if="selected_categories.length > 0">
                  <span v-for="category in selected_categories">{{ category.label }}, </span>
                </template>
                <template v-else>
                  Categories ...
                </template>
                <div class="dropdown-icon">
                  <i class="fal fa-chevron-down"></i>
                </div>
              </div>
              <div class="multi-select-input-inner" v-show="category_dropdown_open">
                <div class="multi-select-input-group">
                  <div class="checkboxes">
                    <div class="checkbox level-1" v-for="category in categories">
                      <label>
                        <input type="checkbox" name="epwin_system_types" :value="category.id" v-model="selected_category_ids">
                        <span class="checkbox-label">{{ category.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mb-0 pr-1-xs" style="width: 150px;">
            <div class="multi-select-input">
              <div class="multi-select-input-placeholder" @click="system_dropdown_open = !system_dropdown_open">
                <template v-if="selected_system_types.length > 0">
                  <span v-for="type in selected_system_types">{{ type.label }}, </span>
                </template>
                <template v-else>
                  Systems ...
                </template>
                <div class="dropdown-icon">
                  <i class="fal fa-chevron-down"></i>
                </div>
              </div>
              <div class="multi-select-input-inner" v-show="system_dropdown_open">
                <div class="multi-select-input-group">
                  <div class="checkboxes">
                    <div class="checkbox level-1" v-for="system_type in system_types">
                      <label>
                        <input type="checkbox" name="epwin_system_types" :value="system_type.id" v-model="selected_system_type_ids">
                        <span class="checkbox-label">{{ system_type.label }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div>
            <input type="text" placeholder="Search" class="form-control" v-model="search_query">
          </div>
        </div>
      <template v-if="!loading && total_count > 0">
        <table class="table_list">
          <thead>
          <tr>
            <th>
              Published
            </th>
            <th>
              Title
            </th>
            <th>
              Category
            </th>
            <th>
              Systems
            </th>
            <th></th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="news_post in news_posts">
            <td>
              {{ news_post.formatted_publish_at }}
            </td>
            <td>
              {{ news_post.title }}
            </td>
            <td>
              {{ news_post.category.label }}
            </td>
            <td v-if="news_post.system_types.length > 0">
              <span v-for="(system_type, index) in news_post.system_types">
                <template v-if="index > 0">, </template> {{ system_type.label }}
              </span>
            </td>
            <td v-else>
              N/A
            </td>
            <td class="td_delete">
              <a @click.prevent="deletePost(news_post.id)" class="txt-danger cursor-pointer">
                <i class="fa fa-trash"></i>
              </a>
            </td>
            <td class="td_view">
              <a :href='"/news/edit/"+news_post.id' class="txt-primary">
                <i class="fa fa-eye"></i>
              </a>
            </td>
          </tr>
          </tbody>
        </table>
        <template>
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="!loading && total_count === 0">
        <strong>
          No Results Found
        </strong>
      </template>
    </div>
  </div>
</template>


<script>

export default {
  props: [
    'categories',
    'system_types',
  ],
  data() {
    return {
      news_posts: [],
      search_query: '',
      current_page: 1,
      total_count: 0,
      total_pages: 0,
      selected_category_ids: [],
      selected_system_type_ids: [],
      limit: 20,
      deleting_post: false,
      loading: true,
      system_dropdown_open: false,
      category_dropdown_open: false,
    };
  },
  computed: {
    selected_system_types() {
      return this.system_types.filter((type) => this.selected_system_type_ids.includes(type.id));
    },
    selected_categories() {
      return this.categories.filter((category) => this.selected_category_ids.includes(category.id));
    },
  },
  mounted() {
    this.loadNewsPosts();
  },
  methods: {
    loadNewsPosts: _.debounce(function () {
      axios.post('/news/loadPosts', {
        epwin_system_type_ids: this.selected_system_type_ids,
        category_ids: this.selected_category_ids,
        page_number: this.current_page,
        search_query: this.search_query,
        limit: this.limit,
      }).then((response) => {
        this.news_posts = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
      });
    }, 250),
    prevPage() {
      this.current_page = this.current_page - 1;
      this.loadNewsPosts();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.loadNewsPosts();
    },
    deletePost(post_id) {
      Swal.fire({
        title: 'Are you sure you want to remove this post?',
        text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        this.deleting_post = true;
        if (result.isConfirmed) {
          axios.post('/news/deletePost', {
            post_id: post_id,
          }).then(() => {
            Swal.fire({
              'title': 'Post Deleted',
              'icon': 'success',
            });
            this.current_page = 1;
            this.loadNewsPosts();
            this.deleting_post = false;
          });
        } else {
          this.deleting_post = false;
        }
      });
    },
  },
  watch: {
    search_query() {
      this.current_page = 1;
      this.loadNewsPosts();
    },
    selected_category_id() {
      this.current_page = 1;
      this.loadNewsPosts();
    },
    selected_system_type_ids() {
      this.current_page = 1;
      this.loadNewsPosts();
    },
    selected_category_ids() {
      this.current_page = 1;
      this.loadNewsPosts();
    },
  },
};
</script>
